'use client'

import { ComponentProps } from 'react'
import { ThemeProvider as NextThemesProvider } from 'next-themes'

/**
 * App theme provider (S4.7b — dark mode).
 *
 * Thin 'use client' wrapper around next-themes so it can be mounted from the
 * server `(protected)/layout.tsx`. Mounted ONLY over the authenticated/auth
 * route group — the cast route group has its own separate root layout
 * (`app/cast/layout.tsx`) with no provider, so the `.dark` class can never
 * reach the cast tree (cast stays white by construction).
 */
export function ThemeProvider(
  props: ComponentProps<typeof NextThemesProvider>
) {
  return <NextThemesProvider {...props} />
}
